import React, {useState} from 'react';
// Modal Sheet
import Sheet from 'react-modal-sheet';
// QR
import {QRCodeSVG} from 'qrcode.react';

import { MdFacebook } from 'react-icons/md'
import { AiFillInstagram } from 'react-icons/ai';
import { HiPhone } from 'react-icons/hi';
import { CgWebsite } from 'react-icons/cg'
import { MdQrCodeScanner } from 'react-icons/md';

const QR = () => {
        
    // Set State del modal Sheeet for each modal
    const [isOpen, setOpen] = useState(false);

  return (
    <div>
        <button onClick={() => setOpen(true)}><MdQrCodeScanner className='text-5xl text-white bg-primary p-2 rounded-lg'/> </button>
            <Sheet isOpen={isOpen} onClose={() => setOpen(false)}>
                <Sheet.Container>
                    <Sheet.Header />
                        <Sheet.Content className='mx-12 my-3'>
                        <div className='border-4 border-primary rounded-3xl w-[15rem] h-[15rem] ml-auto mr-auto'>
                        <QRCodeSVG 
                            value="https://casadeblanca.live"
                            className='w-full h-full p-4'
                            />
                        <div className='flex justify-between text-3xl mt-10 rounded-full p-5 bg-primary shadow-lg max-w-[30rem] ml-auto mr-auto'>
                            <a href="https://www.instagram.com/cocina_tradicional_la_casa/" target="_blank" rel='noreferrer' className='hover:duration-150 hover:text-secondary'><AiFillInstagram/> </a>
                            <a href="https://www.facebook.com/cocinalacasadeblanca/" target="_blank" rel='noreferrer' className='hover:duration-150 hover:text-secondary'><MdFacebook/> </a>
                            <a href="tel:+524341156249" target="_blank" rel='noreferrer' className='hover:duration-150 hover:text-secondary'><HiPhone/> </a>  
                            <a href="https://casadeblanca.live" target="_blank" rel='noreferrer' className='hover:duration-150 hover:text-secondary'><CgWebsite/> </a>    
                        </div>
                        </div> 
                        </Sheet.Content>
                    </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>  
    </div>
  )
}

export default QR